<template>
  <div class="pb-12 awards-page">
    <v-container fluid>
      <h2 class="title-text" >Awards</h2>
      <v-row>
        <v-col 
          cols="12"
        >
          <div class="act-item">
            <v-row class="article">
              <v-col
                class="col-sm-12 right-part auto"
              >
                <v-row
                  class="title-div"
                >
                  <v-col 
                    :cols="$vuetify.display.mobile ? 12:5"
                    class="pr-0 pt-0 pb-0"
                    :class="{ 'pb-0': $vuetify.display.mobile }"
                  >
                    <p>01 May 2025</p>
                  </v-col>
                  <v-col
                    :cols="$vuetify.display.mobile ? 12:7"
                    class="pt-0 pb-0"
                    :class="{ 'pt-0': $vuetify.display.mobile }"
                  >
                    <a href="/awardsMay2025">
                      <h2 class="blog-title">Happy Company Award 2025</H2>
                    </a>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="article">
              <v-col
                class="col-sm-12 right-part auto"
              >
                <v-row
                  class="title-div"
                >
                  <v-col 
                    :cols="$vuetify.display.mobile ? 12:5"
                    class="pr-0 pt-0 pb-0"
                    :class="{ 'pb-0': $vuetify.display.mobile }"
                  >
                    <p>01 November 2023</p>
                  </v-col>
                  <v-col
                    :cols="$vuetify.display.mobile ? 12:7"
                    class="pt-0 pb-0"
                    :class="{ 'pt-0': $vuetify.display.mobile }"
                  >
                    <a href="/awardsNov2023">
                      <h2 class="blog-title">2022 Hong Kong Awards for Environmental Excellence (HKAEE)</H2>
                    </a>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="article">
              <v-col
                class="col-sm-12 right-part auto"
              >
                <v-row
                  class="title-div"
                >
                  <v-col 
                    :cols="$vuetify.display.mobile ? 12:5"
                    class="pr-0 pt-0 pb-0"
                    :class="{ 'pb-0': $vuetify.display.mobile }"
                  >
                    <p>10 October 2023</p>
                  </v-col>
                  <v-col
                    :cols="$vuetify.display.mobile ? 12:7"
                    class="pt-0 pb-0"
                    :class="{ 'pt-0': $vuetify.display.mobile }"
                  >
                    <a href="/awardsOct2023">
                      <h2 class="blog-title">Good MPF Employer Award 2023</H2>
                    </a>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="article">
              <v-col
                class="col-sm-12 right-part auto"
              >  
                <v-row
                  class="title-div"
                >
                  <v-col 
                    :cols="$vuetify.display.mobile ? 12:5"
                    class="pr-0 pt-0 pb-0"
                    :class="{ 'pb-0': $vuetify.display.mobile }"
                  >
                    <p>27 June 2023</p>
                  </v-col>
                  <v-col
                    :cols="$vuetify.display.mobile ? 12:7"
                    class="pt-0 pb-0"
                    :class="{ 'pt-0': $vuetify.display.mobile }"
                  >
                    <a href="/awardsJune2023">
                      <h2 class="blog-title">5th Year Caring Company Award (Mar 2023)</H2>
                    </a>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="article">
              <v-col
                class="col-sm-12 right-part auto"
              >  
                <v-row
                  class="title-div"
                >
                  <v-col 
                    :cols="$vuetify.display.mobile ? 12:5"
                    class="pr-0 pt-0 pb-0"
                    :class="{ 'pb-0': $vuetify.display.mobile }"
                  >
                    <p>01 September 2022</p>
                  </v-col>
                  <v-col
                    :cols="$vuetify.display.mobile ? 12:7"
                    class="pt-0 pb-0"
                    :class="{ 'pt-0': $vuetify.display.mobile }"
                  >
                    <a href="/awardsSept2022">
                      <h2 class="blog-title">Good MPF Employer Award 2022</H2>
                    </a>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="article">
              <v-col
                class="col-sm-12 right-part auto"
              >  
                <v-row
                  class="title-div"
                >
                  <v-col 
                    :cols="$vuetify.display.mobile ? 12:5"
                    class="pr-0 pt-0 pb-0"
                    :class="{ 'pb-0': $vuetify.display.mobile }"
                  >
                    <p>20 June 2022</p>
                  </v-col>
                  <v-col
                    :cols="$vuetify.display.mobile ? 12:7"
                    class="pt-0 pb-0"
                    :class="{ 'pt-0': $vuetify.display.mobile }"
                  >
                    <a href="/awardsJune2022">
                      <h2 class="blog-title">Happy Company Award 2022</H2>
                    </a>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="article">
              <v-col
                class="col-sm-12 right-part auto"
              >  
                <v-row
                  class="title-div"
                >
                  <v-col 
                    :cols="$vuetify.display.mobile ? 12:5"
                    class="pr-0 pt-0 pb-0"
                    :class="{ 'pb-0': $vuetify.display.mobile }"
                  >
                    <p>26 May 2022</p>
                  </v-col>
                  <v-col
                    :cols="$vuetify.display.mobile ? 12:7"
                    class="pt-0 pb-0"
                    :class="{ 'pt-0': $vuetify.display.mobile }"
                  >
                    <a href="/awardsMay2022">
                      <h2 class="blog-title">Hong Kong’s Most Outstanding Business Awards 2022</H2>
                    </a>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="article">
              <v-col
                class="col-sm-12 right-part auto"
              >  
                <v-row
                  class="title-div"
                >
                  <v-col 
                    :cols="$vuetify.display.mobile ? 12:5"
                    class="pr-0 pt-0 pb-0"
                    :class="{ 'pb-0': $vuetify.display.mobile }"
                  >
                    <p>20 May 2019</p>
                  </v-col>
                  <v-col
                    :cols="$vuetify.display.mobile ? 12:7"
                    class="pt-0 pb-0"
                    :class="{ 'pt-0': $vuetify.display.mobile }"
                  >
                    <a href="/awardsMay2019">
                      <h2 class="blog-title">Caring Company Award Presentation to LeachGarner Hong Kong</H2>
                    </a>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>


<script>

export default {
  name: "AwardsPage",
}
</script>

<style>
@media screen and (max-width: 960px) {
  .awards-page {
    padding-top: 40px;
  }
}

@media (max-width: 991px) {
  .article {
    padding-top: 0px;
  }

  h2.blog-title {
    font-size: 20px;
  }

}

</style>
